/**
 * Single source of truth per i breakpoint responsive del backoffice.
 *
 * Allineati ai breakpoint di default di Material-UI v4 (gia' usati dallo shell
 * tramite <Hidden /> e theme.breakpoints), cosi' CSS e JS condividono le stesse
 * soglie. NB: NON coincidono con i breakpoint del tema Bootstrap/Rubix
 * ($screen-sm-min: 990px, ...), che restano invariati per non alterare la griglia
 * esistente. Questi valori sono pensati per il nuovo codice responsive.
 *
 * Semantica adottata:
 *   - phone   : < 600px   (smartphone)
 *   - tablet  : 600-959px (tablet, sm/md MUI)
 *   - desktop : >= 960px
 */

export const BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
};

// Soglie semantiche di alto livello usate dai layout.
export const DEVICE_BREAKPOINTS = {
  // Sotto questa soglia: smartphone (layout impilato, vista card, ecc.).
  phoneMaxWidth: BREAKPOINTS.sm - 1, // 599
  // Range tablet.
  tabletMinWidth: BREAKPOINTS.sm, // 600
  tabletMaxWidth: BREAKPOINTS.md - 1, // 959
  // Da qui in su: esperienza desktop piena.
  desktopMinWidth: BREAKPOINTS.md, // 960
};

/**
 * Restituisce il nome del device per una larghezza data.
 * @param {number} width larghezza viewport in px
 * @returns {'phone'|'tablet'|'desktop'}
 */
export function getDeviceForWidth(width) {
  if (width <= DEVICE_BREAKPOINTS.phoneMaxWidth) return 'phone';
  if (width <= DEVICE_BREAKPOINTS.tabletMaxWidth) return 'tablet';
  return 'desktop';
}

export default BREAKPOINTS;
